// extracted by mini-css-extract-plugin
module.exports = {"tabs":"ListTab_tabs__35F21","tabs__tab":"ListTab_tabs__tab__3ngy4","tabs__tab--active":"ListTab_tabs__tab--active__2ZlNG"};